module.exports = __webpack_public_path__ + "static/img/homeSubBanner.4efcd97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeSubBanner.png
// module id = 7NTQ
// module chunks = 1